import React from 'react';
import {
  Button,
  Circle,
  DatePicker,
  ExpoImage,
  Icon,
  Picker,
  Pressable,
  ScreenContainer,
  SimpleStyleFlatList,
  SimpleStyleKeyboardAwareScrollView,
  Surface,
  TextInput,
  Touchable,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { BlurView } from 'expo-blur';
import { ActivityIndicator, Image, Modal, Text, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Fetch } from 'react-request';
import * as GlobalStyles from '../GlobalStyles.js';
import * as LeadFunlDefaultApi from '../apis/LeadFunlDefaultApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import openImagePickerUtil from '../utils/openImagePicker';
import useWindowDimensions from '../utils/useWindowDimensions';

const DashboardScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [age, setAge] = React.useState('');
  const [clientImage, setClientImage] = React.useState('');
  const [dobInp, setDobInp] = React.useState('');
  const [emailInp, setEmailInp] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [nameInp, setNameInp] = React.useState('');
  const [showAddClientModal, setShowAddClientModal] = React.useState(false);
  const [statePickerOptions, setStatePickerOptions] = React.useState([]);
  const [statePickerValue, setStatePickerValue] = React.useState('');
  const [textInputValue, setTextInputValue] = React.useState('');
  const validateUserInput = (name, email, dob, state_id, photo) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!name || name.trim().length < 3) {
      setErrorMessage('Name must be at least 3 characters long.');
      return false;
    }

    // if (!photo) {
    //   setErrorMessage("Client Image is required.");
    //   return false;
    // }

    // Email validation
    if (!email) {
      setErrorMessage('Email is required.');
      return false;
    }
    if (!emailRegex.test(email)) {
      setErrorMessage('Invalid email format.');
      return false;
    }

    // State ID validation
    if (!state_id) {
      setErrorMessage('Please select a state from the list.');
      return false;
    }

    if (!age) {
      setErrorMessage('Age is required.');
      return false;
    }

    let parsedAge = parseInt(age);

    if (parsedAge > 0) {
    } else {
      setErrorMessage('Please enter a valid age');
      return false;
    }

    // Clear error message if validation passes
    setErrorMessage('');
    return true;
  };
  const safeAreaInsets = useSafeAreaInsets();
  const leadFunlDefaultPostAClientPOST =
    LeadFunlDefaultApi.usePostAClientPOST();
  const isFocused = useIsFocused();
  React.useEffect(() => {
    const handler = async () => {
      try {
        if (!isFocused) {
          return;
        }
        const res = (await LeadFunlDefaultApi.authMeGET(Constants))?.json;
        if (res?.id) {
          setGlobalVariableValue({
            key: 'AUTH_USER',
            value: res,
          });
        }
      } catch (err) {
        console.error(err);
      }
    };
    handler();
  }, [isFocused]);

  return (
    <ScreenContainer hasSafeArea={false} scrollable={false}>
      {/* Container */}
      <View
        style={StyleSheet.applyWidth({ flex: 1, padding: 8 }, dimensions.width)}
      >
        {/* Header */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'center',
              flexDirection: 'row',
              height: 48,
              justifyContent: 'space-between',
              padding: 5,
              paddingRight: 0,
            },
            dimensions.width
          )}
        >
          {/* Image 2 */}
          <ExpoImage
            allowDownscaling={true}
            cachePolicy={'disk'}
            contentPosition={'center'}
            transitionDuration={300}
            transitionEffect={'cross-dissolve'}
            transitionTiming={'ease-in-out'}
            {...GlobalStyles.ExpoImageStyles(theme)['Image 2'].props}
            resizeMode={'contain'}
            source={imageSource(Images['officedotlogo'])}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.ExpoImageStyles(theme)['Image 2'].style,
                {
                  height: [
                    { minWidth: Breakpoints.Mobile, value: 50 },
                    { minWidth: Breakpoints.Tablet, value: 65 },
                  ],
                  width: [
                    { minWidth: Breakpoints.Tablet, value: 130 },
                    { minWidth: Breakpoints.Laptop, value: 140 },
                  ],
                }
              ),
              dimensions.width
            )}
          />
          <Pressable
            onPress={() => {
              try {
                navigation.navigate('ProfileScreen');
              } catch (err) {
                console.error(err);
              }
            }}
            activeOpacity={0.3}
          >
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: 'center',
                  height: 48,
                  justifyContent: 'center',
                  width: 48,
                },
                dimensions.width
              )}
            >
              <Icon
                size={24}
                color={theme.colors.branding.primary}
                name={'FontAwesome/gears'}
              />
            </View>
          </Pressable>
        </View>
        {/* Content */}
        <View style={StyleSheet.applyWidth({ flex: 1 }, dimensions.width)}>
          <LeadFunlDefaultApi.FetchGetAllClientsGET>
            {({ loading, error, data, refetchGetAllClients }) => {
              const fetchData = data?.json;
              if (loading) {
                return <ActivityIndicator />;
              }

              if (error || data?.status < 200 || data?.status >= 300) {
                return <ActivityIndicator />;
              }

              return (
                <SimpleStyleFlatList
                  data={(() => {
                    const e = fetchData;
                    console.log(e);
                    return e;
                  })()}
                  decelerationRate={'normal'}
                  horizontal={false}
                  inverted={false}
                  keyExtractor={(listData, index) =>
                    listData?.id ??
                    listData?.uuid ??
                    index?.toString() ??
                    JSON.stringify(listData)
                  }
                  keyboardShouldPersistTaps={'never'}
                  listKey={'Container->Content->Fetch->List'}
                  nestedScrollEnabled={false}
                  numColumns={1}
                  onEndReachedThreshold={0.5}
                  pagingEnabled={false}
                  renderItem={({ item, index }) => {
                    const listData = item;
                    return (
                      <Pressable
                        onPress={() => {
                          try {
                            navigation.navigate('ReportScreen', {
                              client: listData,
                            });
                          } catch (err) {
                            console.error(err);
                          }
                        }}
                        activeOpacity={0.3}
                      >
                        <Surface
                          {...GlobalStyles.SurfaceStyles(theme)['Surface']
                            .props}
                          elevation={3}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.SurfaceStyles(theme)['Surface']
                                .style,
                              {
                                borderColor: palettes.Slate[300],
                                borderWidth: 1,
                                flexWrap: 'nowrap',
                                marginBottom: 12,
                              }
                            ),
                            dimensions.width
                          )}
                        >
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                alignItems: 'center',
                                backgroundColor: palettes.Gray[100],
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                padding: 15,
                              },
                              dimensions.width
                            )}
                          >
                            <ExpoImage
                              allowDownscaling={true}
                              cachePolicy={'disk'}
                              contentPosition={'center'}
                              resizeMode={'cover'}
                              transitionDuration={300}
                              transitionEffect={'cross-dissolve'}
                              transitionTiming={'ease-in-out'}
                              {...GlobalStyles.ExpoImageStyles(theme)['Image 3']
                                .props}
                              source={imageSource(
                                listData?.client_image
                                  ? listData?.client_image?.url
                                  : Images['placeholderimage']
                              )}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.ExpoImageStyles(theme)['Image 3']
                                    .style,
                                  { borderRadius: 25, height: 50, width: 50 }
                                ),
                                dimensions.width
                              )}
                            />
                            {/* View 3 */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: 'center',
                                  flex: 1,
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                  marginLeft: 15,
                                },
                                dimensions.width
                              )}
                            >
                              {/* Details */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: 'flex-start',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-start',
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Name */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        fontFamily: 'Poppins_500Medium',
                                        fontSize: 15,
                                        textTransform: 'capitalize',
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {listData?.name}
                                </Text>
                                {/* Email */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        fontFamily: 'Poppins_300Light',
                                        fontSize: 13,
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {listData?.email}
                                </Text>
                              </View>
                              {/* Arrow */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  },
                                  dimensions.width
                                )}
                              >
                                <Icon
                                  size={24}
                                  color={theme.colors.branding.primary}
                                  name={'Feather/chevron-right'}
                                />
                              </View>
                            </View>
                          </View>
                        </Surface>
                      </Pressable>
                    );
                  }}
                  snapToAlignment={'start'}
                  showsHorizontalScrollIndicator={false}
                  showsVerticalScrollIndicator={false}
                  style={StyleSheet.applyWidth(
                    { paddingTop: 10 },
                    dimensions.width
                  )}
                />
              );
            }}
          </LeadFunlDefaultApi.FetchGetAllClientsGET>
        </View>
        {/* Footer */}
        <View>
          {/* + Add New Client */}
          <Button
            accessible={true}
            iconPosition={'left'}
            onPress={() => {
              try {
                setShowAddClientModal(true);
              } catch (err) {
                console.error(err);
              }
            }}
            {...GlobalStyles.ButtonStyles(theme)['Button'].props}
            activeOpacity={0.3}
            icon={'Ionicons/person-add'}
            iconSize={18}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.ButtonStyles(theme)['Button'].style,
                { fontFamily: 'Poppins_400Regular' }
              ),
              dimensions.width
            )}
            title={'  Add New Client'}
          />
        </View>
      </View>
      {/*  Absolute view - Add New Client */}
      <>
        {!showAddClientModal ? null : (
          <View
            style={StyleSheet.applyWidth(
              {
                height: '100%',
                paddingTop: safeAreaInsets.top,
                position: 'absolute',
                width: '100%',
                zIndex: 99,
              },
              dimensions.width
            )}
          >
            <BlurView
              experimentalBlurMethod={'none'}
              intensity={50}
              tint={'default'}
              {...GlobalStyles.BlurViewStyles(theme)['Blur View'].props}
              style={StyleSheet.applyWidth(
                StyleSheet.compose(
                  GlobalStyles.BlurViewStyles(theme)['Blur View'].style,
                  { padding: 8 }
                ),
                dimensions.width
              )}
            >
              {/* Header */}
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignItems: 'center',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                  },
                  dimensions.width
                )}
              >
                {/* Close */}
                <Pressable
                  onPress={() => {
                    try {
                      setShowAddClientModal(false);
                      setClientImage('');
                      setNameInp('');
                      setEmailInp('');
                      setStatePickerValue('');
                      setDobInp('');
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  activeOpacity={0.3}
                >
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: 'center',
                        height: 48,
                        justifyContent: 'center',
                        width: 48,
                      },
                      dimensions.width
                    )}
                  >
                    <Icon
                      size={24}
                      color={theme.colors.branding.primary}
                      name={'Entypo/cross'}
                    />
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            color: theme.colors.branding.primary,
                            fontSize: 10,
                            textAlign: 'center',
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Close'}
                    </Text>
                  </View>
                </Pressable>
              </View>

              <SimpleStyleKeyboardAwareScrollView
                enableAutomaticScroll={false}
                enableOnAndroid={false}
                enableResetScrollToCoords={false}
                keyboardShouldPersistTaps={'never'}
                viewIsInsideTabBar={false}
                showsVerticalScrollIndicator={false}
                style={StyleSheet.applyWidth(
                  { flex: 1, paddingBottom: 10 },
                  dimensions.width
                )}
              >
                {/* Image */}
                <View
                  style={StyleSheet.applyWidth(
                    { alignItems: 'center', paddingBottom: 20, paddingTop: 20 },
                    dimensions.width
                  )}
                >
                  <Touchable
                    onPress={() => {
                      const handler = async () => {
                        try {
                          const result = await openImagePickerUtil({
                            mediaTypes: 'All',
                            allowsEditing: false,
                            quality: 0.2,
                            allowsMultipleSelection: false,
                            selectionLimit: 0,
                            outputBase64: true,
                          });

                          setClientImage(result);
                        } catch (err) {
                          console.error(err);
                        }
                      };
                      handler();
                    }}
                  >
                    <View>
                      <Circle
                        bgColor={theme.colors.text.light}
                        size={140}
                        style={StyleSheet.applyWidth(
                          { height: 70, width: 70 },
                          dimensions.width
                        )}
                      >
                        <Image
                          resizeMode={'cover'}
                          source={imageSource(Images['placeholderimage'])}
                          style={StyleSheet.applyWidth(
                            { borderRadius: 70, height: 140, width: 140 },
                            dimensions.width
                          )}
                        />
                        <Image
                          resizeMode={'cover'}
                          source={imageSource(`${clientImage}`)}
                          style={StyleSheet.applyWidth(
                            {
                              borderRadius: 70,
                              height: 140,
                              position: 'absolute',
                              top: 0,
                              width: 140,
                            },
                            dimensions.width
                          )}
                        />
                      </Circle>
                    </View>
                  </Touchable>
                </View>
                {/* Name */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      backgroundColor: palettes.App['Custom Color_3'],
                      borderRadius: 24,
                      height: 48,
                      marginLeft: 20,
                      marginRight: 20,
                      marginTop: 15,
                    },
                    dimensions.width
                  )}
                >
                  <TextInput
                    autoCapitalize={'none'}
                    autoCorrect={true}
                    changeTextDelay={500}
                    onChangeText={newTextInputValue => {
                      try {
                        setNameInp(newTextInputValue);
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    webShowOutline={true}
                    autoComplete={'name'}
                    editable={true}
                    placeholder={'Name'}
                    placeholderTextColor={theme.colors.text.light}
                    style={StyleSheet.applyWidth(
                      {
                        borderBottomWidth: 1,
                        borderColor: theme.colors.branding.primary,
                        borderLeftWidth: 1,
                        borderRadius: 25,
                        borderRightWidth: 1,
                        borderTopWidth: 1,
                        color: palettes.App['Custom Color'],
                        fontFamily: 'Poppins_400Regular',
                        fontSize: 15,
                        height: 48,
                        paddingBottom: 8,
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingTop: 8,
                      },
                      dimensions.width
                    )}
                    value={nameInp}
                  />
                </View>
                {/* Age */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      backgroundColor: palettes.App['Custom Color_3'],
                      borderRadius: 24,
                      height: 48,
                      marginLeft: 20,
                      marginRight: 20,
                      marginTop: 15,
                    },
                    dimensions.width
                  )}
                >
                  <TextInput
                    autoCapitalize={'none'}
                    autoCorrect={true}
                    changeTextDelay={500}
                    onChangeText={newTextInputValue => {
                      try {
                        setAge(newTextInputValue);
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    webShowOutline={true}
                    editable={true}
                    keyboardType={'numeric'}
                    placeholder={'Age'}
                    placeholderTextColor={theme.colors.text.light}
                    style={StyleSheet.applyWidth(
                      {
                        borderBottomWidth: 1,
                        borderColor: theme.colors.branding.primary,
                        borderLeftWidth: 1,
                        borderRadius: 25,
                        borderRightWidth: 1,
                        borderTopWidth: 1,
                        color: palettes.App['Custom Color'],
                        fontFamily: 'Poppins_400Regular',
                        fontSize: 15,
                        height: 48,
                        paddingBottom: 8,
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingTop: 8,
                      },
                      dimensions.width
                    )}
                    value={age}
                  />
                </View>
                {/* Email */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      backgroundColor: palettes.App['Custom Color_3'],
                      borderColor: theme.colors.branding.primary,
                      borderRadius: 24,
                      borderWidth: 1,
                      height: 48,
                      marginLeft: 20,
                      marginRight: 20,
                      marginTop: 15,
                    },
                    dimensions.width
                  )}
                >
                  <TextInput
                    autoCapitalize={'none'}
                    autoCorrect={true}
                    changeTextDelay={500}
                    onChangeText={newTextInputValue => {
                      try {
                        setEmailInp(newTextInputValue);
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    editable={true}
                    keyboardType={'email-address'}
                    placeholder={'Email'}
                    placeholderTextColor={theme.colors.text.light}
                    style={StyleSheet.applyWidth(
                      {
                        borderBottomWidth: 1,
                        borderColor: theme.colors.border.brand,
                        borderLeftWidth: 1,
                        borderRadius: 25,
                        borderRightWidth: 1,
                        borderTopWidth: 1,
                        color: palettes.App['Custom Color'],
                        fontFamily: 'Poppins_400Regular',
                        fontSize: 15,
                        height: 48,
                        paddingBottom: 8,
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingTop: 8,
                      },
                      dimensions.width
                    )}
                    textContentType={'emailAddress'}
                    value={emailInp}
                    webShowOutline={false}
                  />
                </View>

                <LeadFunlDefaultApi.FetchGetAllStatesGET
                  handlers={{
                    onData: fetchData => {
                      try {
                        setStatePickerOptions(
                          fetchData?.map(({ id, name }) => ({
                            label: name,
                            value: id,
                          }))
                        );
                      } catch (err) {
                        console.error(err);
                      }
                    },
                  }}
                >
                  {({ loading, error, data, refetchGetAllStates }) => {
                    const fetchData = data?.json;
                    if (loading) {
                      return <View />;
                    }

                    if (error || data?.status < 200 || data?.status >= 300) {
                      return (
                        <>
                          {/* View 2 */}
                          <View />
                        </>
                      );
                    }

                    return null;
                  }}
                </LeadFunlDefaultApi.FetchGetAllStatesGET>
                {/* Location */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      backgroundColor: palettes.App['Custom Color_3'],
                      borderColor: theme.colors.branding.primary,
                      borderRadius: 24,
                      borderWidth: 1,
                      height: 48,
                      marginLeft: 20,
                      marginRight: 20,
                      marginTop: 15,
                    },
                    dimensions.width
                  )}
                >
                  <Picker
                    autoDismissKeyboard={true}
                    dropDownBorderRadius={8}
                    dropDownBorderWidth={1}
                    dropDownTextColor={theme.colors.text.strong}
                    iconSize={24}
                    leftIconMode={'inset'}
                    mode={'native'}
                    onValueChange={newPickerValue => {
                      try {
                        setStatePickerValue(newPickerValue);
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    selectedIconColor={theme.colors.text.strong}
                    selectedIconName={'Feather/check'}
                    selectedIconSize={20}
                    type={'solid'}
                    dropDownBackgroundColor={'rgba(0, 0, 0, 0)'}
                    dropDownBorderColor={'rgba(0, 0, 0, 0)'}
                    options={statePickerOptions}
                    placeholder={'State'}
                    style={StyleSheet.applyWidth(
                      { borderColor: 'rgba(0, 0, 0, 0)', marginTop: -8 },
                      dimensions.width
                    )}
                    value={statePickerValue}
                  />
                  <Icon
                    color={theme.colors.text.light}
                    name={'AntDesign/down'}
                    size={20}
                    style={StyleSheet.applyWidth(
                      { position: 'absolute', right: 16, top: 12 },
                      dimensions.width
                    )}
                  />
                </View>
                {/* error */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: 'center',
                      height: 32,
                      justifyContent: 'center',
                    },
                    dimensions.width
                  )}
                >
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Text'].props}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        { color: palettes.Brand.Error }
                      ),
                      dimensions.width
                    )}
                  >
                    {errorMessage}
                  </Text>
                </View>
              </SimpleStyleKeyboardAwareScrollView>
              {/* Footer */}
              <View>
                {/* Submit */}
                <Button
                  accessible={true}
                  iconPosition={'left'}
                  onPress={() => {
                    const handler = async () => {
                      try {
                        const isValid = validateUserInput(
                          nameInp,
                          emailInp,
                          dobInp,
                          statePickerValue,
                          clientImage
                        );
                        if (!isValid) {
                          return;
                        }
                        setIsLoading(true);
                        const result = (
                          await leadFunlDefaultPostAClientPOST.mutateAsync({
                            age: age,
                            date_of_birth: dobInp,
                            email: emailInp,
                            image: clientImage,
                            name: nameInp,
                            states_id: statePickerValue,
                          })
                        )?.json;
                        setIsLoading(false);
                        if (result?.status) {
                          setShowAddClientModal(false);
                          setNameInp('');
                          setEmailInp('');
                          setAge('');
                          setDobInp('');
                          setStatePickerValue('');
                        } else {
                          setErrorMessage(result?.message);
                        }
                      } catch (err) {
                        console.error(err);
                      }
                    };
                    handler();
                  }}
                  {...GlobalStyles.ButtonStyles(theme)['Button'].props}
                  activeOpacity={0.3}
                  iconSize={18}
                  loading={Boolean(isLoading)}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.ButtonStyles(theme)['Button'].style,
                      { fontFamily: 'Poppins_400Regular' }
                    ),
                    dimensions.width
                  )}
                  title={'Submit'}
                />
              </View>
            </BlurView>
          </View>
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(DashboardScreen);
